export default {
  admin: [
    {
      icon: "fa fa-play-circle",
      label: "module.video",
      group: [
        {
          label: "page.video",
          route: {
            name: "admin.video-list",
            query: {
              page: 1,
              sort: "created_at=desc",
            },
          },
          roles: ["ROLE_ADMIN", "ROLE_VIDEO"],
        },

        {
          label: "page.series",
          route: {
            name: "admin.series-list",
            query: {
              page: 1,
              sort: "created_at=desc",
            },
          },
          roles: ["ROLE_ADMIN", "ROLE_VIDEO"],
        },

        {
          label: "page.series.category",
          route: {
            name: "admin.series-category-tree",
          },
          roles: ["ROLE_ADMIN", "ROLE_VIDEO"],
        },
        {
          label: "page.video_preview",
          route: {
            name: "admin.video-preview-list",
            query: {
              page: 1,
              sort: "created_at=desc",
            },
          },
          roles: ["ROLE_ADMIN", "ROLE_VIDEO"],
        },
      ],
    },

    {
      icon: "fa fa-video",
      label: "節目表與側錄",
      group: [
        {
          label: "page.program-config",
          route: {
            name: "admin.program-config-list",
            query: {
              page: 1,
              sort: "created_at=desc",
            },
          },
          roles: ["ROLE_ADMIN", "ROLE_PROGRAM"],
        },

        {
          label: "page.program",
          route: {
            name: "admin.program",
          },
          roles: ["ROLE_ADMIN", "ROLE_PROGRAM"],
        },
      ],
    },
  ],
};
